import { StyleProp, ViewStyle } from "react-native";
import { useTheme } from "react-native-paper";
import Svg, { Path } from "react-native-svg";

type Props = {
  style?: StyleProp<ViewStyle>;
  color?: string;
};

export default function Yappy({ style, color }: Props) {
  const { colors } = useTheme();

  return (
    <Svg viewBox="0 0 650 650" width={24} height={24} style={style}>
      <Path
        id="yappy"
        fill={color || colors.onSurfaceVariant}
        d="m524 148.4c34.5 8 62.4 26 83 53.4 18.5 24.6 28 53.3 28 84.2 0 23.7-4.1 41.5-14.4 62.5-7.7 15.6-15.9 27-27.6 38.5-30.5 29.9-70.8 43.9-115 40-43-3.8-91.8-18.3-135.5-40.4-20.6-10.4-30.3-16.6-39.1-24.8-9.7-9.1-11.8-16.1-5.7-18.7 1.8-0.7 9-1 20.8-0.9 16.6 0.3 18.4 0.1 22.6-1.8 9.7-4.5 11.2-10.6 11.4-45.4 0.2-25 0.3-27.2 2.9-38.5 6.4-27.8 18.9-50.5 38.8-70.2 22.9-22.5 49.8-35.8 81.8-40.3 11.6-1.6 36.2-0.4 48 2.4zm-346.5 106.6c24.5 2.3 57 8.9 80.5 16.5 31.8 10.3 53.7 23.3 52.8 31.3-0.5 4.1-5.3 5.8-20.3 7.1-14.8 1.3-20.5 3.4-24.2 8.9-4.1 6.2-4.1 15-0.2 38 2.3 14 2.5 32.3 0.3 44.7-5.8 33.4-25.8 64-54.2 82.9-37.7 25.1-84.3 28.3-124.7 8.7-54.2-26.4-82.4-87.5-66.9-145.3 13.2-49.4 56.3-86.8 106.7-92.7 10.4-1.2 37.4-1.3 50.2-0.1z"
      />
    </Svg>
  );
}
